// extracted by mini-css-extract-plugin
export var container = "sectionIndicator-module--container--29Ul2";
export var lineWrapper = "sectionIndicator-module--line-wrapper--1Ey3-";
export var line = "sectionIndicator-module--line--3VjuC";
export var active = "sectionIndicator-module--active--3cWSs";